












import { Component, Vue } from 'vue-property-decorator';
import { DynamicComponent } from '@/common/types';
import Sidebar from '@/components/Global/Sidebar/Sidebar.vue';
import Brand from '@/services/Brand';
import Staff from '@/services/Staff';
import User from '@/services/User';
import { Getter, State } from 'vuex-class';
@Component({
	name: 'PageHome',
	components: {
		Sidebar,
	},
})
export default class Home extends Vue {
	private applicationPendingWidget: DynamicComponent = () => null;
	private component: DynamicComponent = () => null;
	@State('user', { namespace: 'Auth' }) private user;
	private approvals: any;
	private newApprovals: any;
	private userEmail: string;
	private filteredApproval: any;
	private mounted() {
		switch (Brand.getBrand()) {
			case 'insurecareteams':
				this.applicationPendingWidget = () =>
					import(
						// tslint:disable-next-line:max-line-length
						/* webpackChunkName: "ict" */ '@/components/Home/InsureCareTeams/ApplicationPendingWidget.vue'
					);
				this.component = () =>
					import(
						// tslint:disable-next-line:max-line-length
						/* webpackChunkName: "ict" */ '@/pages/Home/InsureCareTeams/InsureCareDashboard.vue'
					);
				break;

			default:
				this.component = () =>
					import(
						// tslint:disable-next-line:max-line-length
						/* webpackChunkName: "global-dashboard" */ '@/pages/Home/Global/Dashboard.vue'
					);
				break;
		}
	}

	constructor() {
		super();

		this.approvals = [];
		this.newApprovals = [];
		this.filteredApproval = null;
		this.userEmail = '';
	}
	private async created() {
		if (window.newUserRegistered) {
			this.$router.push({
				name: 'signout',
			});
		}

		const getApprovals = await Staff.getApprovals();

		this.approvals = getApprovals.data;

		if (this.user) {
			this.userEmail = this.user.email;
		}

		this.approvals.forEach((approval) => {
			if (!('body' in approval)) {
				this.newApprovals.push(approval);
			}
		});
		this.filteredApproval = this.newApprovals.filter(
			(value) =>
				value.email === this.userEmail &&
				value.category === 'Risk Resources' &&
				value.brand === Brand.getBrand(),
		);

		if (this.filteredApproval.length > 0) {
			this.$store.dispatch('Registration/setupRiskResourcesRequested', true);
		}

		this.filteredApproval = this.newApprovals.filter(
			(value) =>
				value.email === this.userEmail &&
				value.category === 'Reports' &&
				value.brand === Brand.getBrand(),
		);
		if (this.filteredApproval.length > 0) {
			this.$store.dispatch('Registration/setupReportsRequested', true);
		}
	}
}
